import type { FeaturesCategoriesContent } from '@/core/types';

import { FeaturesCategories } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: FeaturesCategoriesContent;
  className?: string;
}) {
  return (
    <FeaturesCategories
      title={content.title}
      description={content.description}
      items={content.items}
      buttons={content.buttons}
      className={className}
    />
  );
}
